import _extends from "@babel/runtime/helpers/extends";
import fetchRequest from '@ysf/fetch';
import { Cookie } from '@ysf/helper';
var token = Cookie.get('__csrfToken') || '';
export var setToken = function setToken(tokenParams) {
  Cookie.set('__csrfToken', token || '');
  token = tokenParams;
};
export var request = function request(url, option) {
  var _window, _window$setting;
  if (option === void 0) {
    option = {};
  }
  var _option = option,
    _option$params = _option.params,
    params = _option$params === void 0 ? {} : _option$params;
  // 把token塞一份到params
  option = _extends({}, option, {
    params: _extends({}, params, {
      token: params.token ? params.token : token || ((_window = window) === null || _window === void 0 ? void 0 : (_window$setting = _window.setting) === null || _window$setting === void 0 ? void 0 : _window$setting.token)
    })
  });
  return fetchRequest(url, option);
};
/**
 * 查询国际化的语言包
 * @param data
 */
export var queryLangJson = function queryLangJson(data) {
  return request('/jingwei/query/language/byLocationAndLang/get', {
    params: data
  });
};